import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  LeadCycleRuleRequest,
  LeadCycleRuleResponse,
  LeadCycleRuleSearchParams,
  PageResponse
} from '../models/lead-cycle-rule.model';

@Injectable({
  providedIn: 'root'
})
export class LeadCycleRuleApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/lead-cycle-rules?businessId=&cycleId=&page=&size=
  getRules(searchParams: LeadCycleRuleSearchParams): Observable<PageResponse<LeadCycleRuleResponse>> {
    let params = new HttpParams()
      .set('businessId', searchParams.businessId.toString());
    if (searchParams.cycleId !== undefined) {
      params = params.set('cycleId', searchParams.cycleId.toString());
    }
    if (searchParams.page !== undefined) {
      params = params.set('page', searchParams.page.toString());
    }
    if (searchParams.size !== undefined) {
      params = params.set('size', searchParams.size.toString());
    }
    return this.http.get<PageResponse<LeadCycleRuleResponse>>(`${this.apiUrl}/lead-cycle-rules`, { params });
  }

  // GET /api/lead-cycle-rules/{id}?businessId=
  getRuleById(id: number, businessId: number): Observable<LeadCycleRuleResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<LeadCycleRuleResponse>(`${this.apiUrl}/lead-cycle-rules/${id}`, { params });
  }

  // POST /api/lead-cycle-rules (Manager+)
  createRule(rule: LeadCycleRuleRequest): Observable<LeadCycleRuleResponse> {
    return this.http.post<LeadCycleRuleResponse>(`${this.apiUrl}/lead-cycle-rules`, rule);
  }

  // PUT /api/lead-cycle-rules/{id} (Manager+)
  updateRule(id: number, rule: LeadCycleRuleRequest): Observable<LeadCycleRuleResponse> {
    return this.http.put<LeadCycleRuleResponse>(`${this.apiUrl}/lead-cycle-rules/${id}`, rule);
  }

  // DELETE /api/lead-cycle-rules/{id}?businessId= (Manager+)
  deleteRule(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/lead-cycle-rules/${id}`, { params });
  }
}
